// extracted by mini-css-extract-plugin
export default {"msgM":"_5461a845a5"};